import { trackAnalyticsEvent } from "./gtmDataLayer";

const MAX_JS_ERRORS_PER_SESSION = 20;
const STACK_MAX_LENGTH = 500;

let installed = false;
let errorCount = 0;

function truncateStack(stack) {
  if (!stack || typeof stack !== "string") return undefined;
  return stack.length > STACK_MAX_LENGTH
    ? `${stack.slice(0, STACK_MAX_LENGTH)}…`
    : stack;
}

function isSanitizedScriptError(message, error) {
  return message === "Script error." && !error?.stack;
}

function trackJsError(properties) {
  if (errorCount >= MAX_JS_ERRORS_PER_SESSION) return;
  errorCount += 1;
  try {
    trackAnalyticsEvent("js_error", properties);
  } catch {
    // Never rethrow from analytics handlers
  }
}

/**
 * Installs once: window error + unhandledrejection → Netlify track (cookie-free).
 */
export function installGtmErrorListeners() {
  if (typeof window === "undefined" || installed) return;
  installed = true;

  window.addEventListener("error", (event) => {
    const message = event?.message || event?.error?.message || "Unknown error";
    if (isSanitizedScriptError(message, event?.error)) return;

    trackJsError({
      type: "error",
      message,
      source: event?.filename,
      line: event?.lineno,
      column: event?.colno,
      stack_snippet: truncateStack(event?.error?.stack),
    });
  });

  window.addEventListener("unhandledrejection", (event) => {
    const reason = event?.reason;
    const message =
      typeof reason === "string"
        ? reason
        : reason?.message || "Unhandled promise rejection";
    if (isSanitizedScriptError(message, reason)) return;

    trackJsError({
      type: "unhandledrejection",
      message,
      stack_snippet: truncateStack(reason?.stack),
    });
  });
}
